import React from 'react';
import { Link } from 'react-router-dom';

import './DonateStrip.css'


const DonateStrip: React.FC = () => {

   return (
      <div className='donate_strip'>
         <div className='donate_text'>
            <Link to='/info'>
               <span className='donate_choose neon'> -CHOOSE- </span>
            </Link>&nbsp; &nbsp;
            <a href="https://send.monobank.ua/jar/9d14fEpemt" target="_blank">
               <span className='donate_donate neon'> &#36;DONATE&#36; </span>
            </a>&nbsp; &nbsp;
            <a href="https://t.me/the_way_of_junior" target="_blank">
               <span className='donate_vote neon'> -VOTE- </span>&nbsp;
            </a>
                     <img src="/img/header/cat.gif" alt="" />
                  </div>
      </div>
   )
}

export default DonateStrip;